module.exports = __webpack_public_path__ + "img/brume_tab.17437c9.webp";